import { render, staticRenderFns } from "./InstructorsSelect.vue?vue&type=template&id=552229c7&scoped=true"
import script from "./InstructorsSelect.vue?vue&type=script&lang=js"
export * from "./InstructorsSelect.vue?vue&type=script&lang=js"
import style0 from "./InstructorsSelect.vue?vue&type=style&index=0&id=552229c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552229c7",
  null
  
)

export default component.exports